import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "sw_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  });
  const [config, setConfig] = useState({ free_shipping_threshold: 0, shipping_zones: [] });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/shop/config`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && setConfig(d))
      .catch(() => {});
  }, []);

  const addItem = (p, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.sku === p.sku);
      const max = p.track_inventory ? Math.max(p.inventory_qty, 0) : 10;
      if (existing) {
        return prev.map((i) =>
          i.sku === p.sku
            ? { ...i, qty: Math.min(i.qty + qty, Math.max(max, 1)) }
            : i,
        );
      }
      return [
        ...prev,
        {
          sku: p.sku,
          name: p.name,
          brand: p.brand,
          slug: p.slug,
          price: p.price,
          image: (p.images && p.images[0]?.url) || "",
          type: p.product_type,
          track: p.track_inventory,
          maxQty: max,
          qty: Math.min(qty, Math.max(max, 1)),
        },
      ];
    });
  };

  const setQty = (sku, qty) =>
    setItems((prev) =>
      prev.map((i) =>
        i.sku === sku ? { ...i, qty: Math.max(1, Math.min(qty, Math.max(i.maxQty, 1))) } : i,
      ),
    );

  const removeItem = (sku) => setItems((prev) => prev.filter((i) => i.sku !== sku));
  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.qty * i.price, 0);

  return (
    <CartContext.Provider
      value={{ items, addItem, setQty, removeItem, clear, count, subtotal, config }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
